import { render, staticRenderFns } from "./CoTwoTehnicalProductionForm.vue?vue&type=template&id=554fe0ea&scoped=true&"
import script from "./CoTwoTehnicalProductionForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoTehnicalProductionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554fe0ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('554fe0ea')) {
      api.createRecord('554fe0ea', component.options)
    } else {
      api.reload('554fe0ea', component.options)
    }
    module.hot.accept("./CoTwoTehnicalProductionForm.vue?vue&type=template&id=554fe0ea&scoped=true&", function () {
      api.rerender('554fe0ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/CoTwoTehnicalProductionForm.vue"
export default component.exports